export enum QRCodeErrorCorrectionLevel {
  Low = 'low',
  Medium = 'medium',
  Quartile = 'quartile',
  High = 'high'
}